import {Store, createStore} from 'vuex';
import mapStylesDialogModule, {
  BaseMapStylesState
} from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import trailOverviewMapModule, { TrailOverviewMapState } from "./modules/TrailOverviewMapModule";
import waypointDialogModule, {WaypointDialogState} from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";
import BaseMapDataOverlaysModule, {BaseMapDataOverlaysState} from "../../base_map_dialog/store/modules/./BaseMapDataOverlaysModule";
import BaseMapDataPOIsModule, {BaseMapDataPOIsState} from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import {POIUtility} from "../../../utils/models/POI";

declare global {
  interface Window {
    map: mapboxgl.Map;
    trail_overview_map_vue: any;
    trailCenterX: string;
    trailCenterY: string;
    layerRegistry: any;
    trailId: number;
    trail: any;
    id: number;
    slug: string;
    region_slug: string;
    country_slug: string;
    isForStage: boolean;
    pathLineStringGeoJson: any;
  }
}

export interface RootState {
  mapStyles: BaseMapStylesState,
  trailOverviewMap: TrailOverviewMapState,
  waypoints: WaypointDialogState,
  mapDataOverlays: BaseMapDataOverlaysState,
  mapDataPOIs: BaseMapDataPOIsState,
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: mapStylesDialogModule,
    trailOverviewMap: trailOverviewMapModule,
    waypoints: waypointDialogModule,
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
  }
})

export default store;
